import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

import Modal from "../../Modal";

const CheckAnswerModal = forwardRef(({}, ref) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openModal() {
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={handleCloseModal}>
      <div className="flex min-h-[25vh] flex-col items-center justify-center px-6 text-center text-gray-700">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="mb-4 h-16 w-16 text-yellow-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v2m0 4h.01M12 3C7.03 3 3 7.03 3 12s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9z"
          />
        </svg>
        <h2 className="mb-4 text-xl font-semibold">{t("please_choose_an_answer")}</h2>
        <button
          onClick={handleCloseModal}
          className="rounded-full bg-blue-500 px-6 py-2 font-semibold text-white transition hover:bg-blue-600"
        >
          {t("ok")}
        </button>
      </div>
    </Modal>
  );
});

export default CheckAnswerModal;
